import { SET_DATA, SET_MODE, INITIAL_SET_DATA, RELOAD_ENTRY } from '../actions';

const initialState = {
    mode: '',
    data: {},
    reload: false
};

export default function commonReducer(state = initialState, action) {
    switch (action.type) {
    case INITIAL_SET_DATA:
        return Object.assign({}, state, {
            mode: action.data.mode,
            data: action.data.data,
            theme: action.data.theme
        });
    case SET_MODE:
        return Object.assign({}, state, {
            mode: action.data
        });
    case SET_DATA:
        return Object.assign({}, state, {
            data: action.data
        });
    case RELOAD_ENTRY:
        return Object.assign({}, state, {
            reload: action.data
        });
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/Common.js